import {
    getShapePathWithLayer
} from '../../Helpers/helpers';

const toggleVisibility = (canvasState, command) => command.get('ids')
    .reduce((currentCanvasState, id) => {
        const shapePath = getShapePathWithLayer(canvasState, id);
        return currentCanvasState.setIn(
            [...shapePath, 'isHidden'],
            !currentCanvasState.getIn([...shapePath, 'isHidden'])
        );
    }, canvasState);

export default toggleVisibility;
